"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _reactTable = _interopRequireDefault(require("react-table"));

var _selectTable = _interopRequireDefault(require("react-table/lib/hoc/selectTable"));

require("react-table/react-table.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var defaultSelectInputComponent = function defaultSelectInputComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("input", {
    type: props.selectType || 'checkbox',
    checked: props.checked,
    "aria-label": "".concat(props.checked ? 'Deselect' : 'Select', " ").concat(props.id ? 'this row' : 'all rows'),
    onClick: function onClick(e) {
      var shiftKey = e.shiftKey;
      e.stopPropagation();
      props.onClick(props.id, shiftKey, props.row);
    },
    onChange: function onChange() {}
  });
};

var withDefaultSelectInputComponent = function withDefaultSelectInputComponent(Component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      SelectInputComponent: defaultSelectInputComponent,
      SelectAllInputComponent: defaultSelectInputComponent
    }));
  };
};

var enhance = (0, _recompose.compose)(withDefaultSelectInputComponent, _selectTable["default"]);

var _default = enhance(_reactTable["default"]);

exports["default"] = _default;